import * as React from "react";
import styled from "styled-components";
import { Button } from "components/bootstrap";
const StyledButton = styled(Button)`
  border-radius: 4px;
  width: 110px;
`;
const StepActionButton = ({
  title,
  onClick = void 0,
  to = void 0,
  disabled = false,
  hint = void 0
}) => {
  if (onClick) {
    const handleClick = (e) => {
      e.stopPropagation();
      onClick();
    };
    return /* @__PURE__ */ React.createElement(
      StyledButton,
      {
        title: hint,
        bsStyle: "gray",
        bsSize: "xs",
        "aria-label": title,
        onClick: handleClick,
        disabled
      },
      title
    );
  }
  return /* @__PURE__ */ React.createElement(
    StyledButton,
    {
      role: "link",
      bsStyle: "gray",
      bsSize: "xs",
      "aria-label": title,
      href: to,
      onClick: (e) => e.stopPropagation(),
      target: "_blank",
      rel: "noopener noreferrer",
      title: hint,
      disabled
    },
    title
  );
};
export default StepActionButton;
